import { render, staticRenderFns } from "./UsermappingEditDialog.vue?vue&type=template&id=54a46f4a"
import script from "./UsermappingEditDialog.vue?vue&type=script&lang=js"
export * from "./UsermappingEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports